import { FC, useEffect } from 'react';
import { Avatar } from '@chakra-ui/react';

interface UserLogoProps {
	size?: {
		w: number | string;
		h: number | string;
	};
	fontSize?: string;
}

const UserLogo: FC<UserLogoProps> = ({ size, fontSize = '15px' }) => {
	useEffect(() => {
		const initialsElements = document.getElementsByClassName(
			'chakra-avatar__initials css-1ebyn6',
		);
		Array.from(initialsElements).forEach((initial) => {
			(initial as HTMLElement).style.fontSize = fontSize;
		});
	}, [fontSize]);

	return <Avatar fontSize={fontSize} {...size} />;
};

export default UserLogo;
